/* eslint-disable array-callback-return */
import { decorate, observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";
import Utils from "Utils/utils";

class PricingStore {
  paymentFormObj = {
    address1: "",
    city: "",
    state: "",
    country: "",
    phone: "",
    seats: null,
    annual: false,
    annualDiscount: null,
    price: null,
    annualPrice: null,
    initTeamSeat: null
  };

  // observable
  activePlanData = [];
  paymentFormInfo = this.paymentFormObj;
  selectedPlan = null;
  dataOutreachPlans = {};

  // action
  setFilter = value => {
    this.filter = value;
  };

  setTotalContactValue = value => {
    this.totalContacts = value;
  };

  setSelectedPlan = plan => {
    if (plan?.length > 0) {
      plan.map(item => {
        if (item.name === "PRO") {
          this.selectedPlan = item;
          const { price, annualPrice, annualDiscount } = item;
          this.setPaymentFormInfo({
            price,
            annualPrice,
            annualDiscount
          });
        }
      });
    }
  };

  setPaymentFormInfo(obj) {
    this.paymentFormInfo = { ...this.paymentFormInfo, ...obj };
  }

  getActivePlanDetails = async () => {
    // try {
    //   let config = {
    //     url: URLS.getActiveSubscriptionPlans,
    //     method: "GET"
    //   };
    //   let res = await makeApi(config);
    // console.log("res: ", JSON.stringify(res, null, 2));
    // if (res && res.data && res.data.length > 0) {
    //   // this.activePlanData = res.data;
    //   // this.setSelectedPlan(res.data);
    // } else Utils.showApiFailureResponse(res);
    // } catch (err) {
    //   console.error("Get ActivePlan Details error ", err);
    // }
  };

  getDataOutreachPlans = async () => {
    try {
      let config = {
        url: URLS.getDataOutreachPlans,
        method: "GET"
      };
      let res = await makeApi(config);
      if (res && res.data && Object.keys(res.data).length > 0) {
        this.dataOutreachPlans = res.data;
        this.activePlanData = res.data?.outreachPlans;
        this.setSelectedPlan(res.data?.outreachPlans);
      } else Utils.showApiFailureResponse(res);
    } catch (err) {
      console.error("Get ActivePlan Details error ", err);
    }
  };

  payment = async (data, cbk) => {
    try {
      const config = {
        url: URLS.payment ? URLS.payment : "",
        method: "POST",
        data
      };
      let res = await makeApi(config);
      if (res?.data?.success) {
        cbk(true, res?.data);
      } else {
        cbk(false, res?.data);
      }
    } catch (err) {
      console.error("Payment Failure", err);
      cbk(false);
    }
  };

  // Called after the user completes 3D Secure / OTP so the backend can
  // activate the PENDING subscription.
  confirmPaymentSuccess = async data => {
    try {
      const config = {
        url: URLS.paymentSuccess ? URLS.paymentSuccess : "",
        method: "POST",
        data
      };
      let res = await makeApi(config);
      return res?.data;
    } catch (err) {
      console.error("Payment confirmation failure", err);
    }
    return null;
  };
}

decorate(PricingStore, {
  activePlanData: observable,
  paymentFormInfo: observable,
  dataOutreachPlans: observable,
  setFilter: action,
  setTotalContactValue: action,
  getActivePlanDetails: action,
  getDataOutreachPlans: action,
  setPaymentFormInfo: action,
  payment: action,
  confirmPaymentSuccess: action
});

const pricingStore = new PricingStore();

export default pricingStore;
